export const reducer = (state, action) => {
    switch (action.type) {
        case 'changeState': {
            return action.payload;
        }
        case 'changeCode': {
            return {
                ...state,
                code: action.payload,
                driversCategories: [],
            };
        }
        case 'changeNumber': {
            return {
                ...state,
                number: action.payload,
            };
        }
        case 'changeIssuer': {
            return {
                ...state,
                issuer: action.payload,
            };
        }
        case 'changeIssuerUnitCode': {
            return {
                ...state,
                issuerUnitCode: action.payload,
            };
        }
        case 'changeValidityPeriodBegin': {
            return {
                ...state,
                validityPeriodBegin: action.payload,
            };
        }
        case 'changeValidityPeriodEnd': {
            return {
                ...state,
                validityPeriodEnd: action.payload,
            };
        }
        case 'changeDriversCategories': {
            return {
                ...state,
                driversCategories: action.payload,
            };
        }
    }
};
